class ComponentCountdown extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.endTime = new Date((this.dataset.countdownTo || "").replace(" ", "T")).getTime();

    if (this.update()) {
      this.timer = setInterval(() => this.update(), 1000);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.timer);
  }

  update() {
    const remaining = this.endTime - Date.now();

    if (!Number.isFinite(remaining) || remaining <= 0) {
      this.style.display = "none";
      clearInterval(this.timer);
      return false;
    }

    this.style.display = "";

    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    const seconds = totalSeconds % 60;

    if (this.elements.timer) {
      this.elements.timer.textContent =
        this.formatUnit(hours) + " Hrs : " +
        this.formatUnit(minutes) + " Min : " +
        this.formatUnit(seconds) + " Sec";
      this.elements.timer.style.opacity = 1;
    } else {
      this.elements.days.textContent = this.formatUnit(Math.floor(hours / 24));
      this.elements.hours.textContent = this.formatUnit(hours % 24);
      this.elements.minutes.textContent = this.formatUnit(minutes);
      this.elements.seconds.textContent = this.formatUnit(seconds);
    }

    return true;
  }

  formatUnit(value) {
    return String(value).padStart(2, "0");
  }
}

customElements.define("component-countdown", ComponentCountdown);
